/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface FrUsageAdminService {
  /** @summary List Fr Usage */
  listAdminFrUsage: {
    /** @summary List Fr Usage */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListAdminFrUsageParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListAdminFrUsageSchema,
        options: {
          parameters: ListAdminFrUsageParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListAdminFrUsageData, ListAdminFrUsageError>>
    ): Promise<RequestFnResponse<ListAdminFrUsageData, ListAdminFrUsageError>>;
    /** @summary List Fr Usage */
    getQueryKey(
      parameters: DeepReadonly<ListAdminFrUsageParameters> | void
    ): ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.frUsageAdminService.listAdminFrUsage.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.frUsageAdminService.listAdminFrUsage.useQuery({
     *     query: {
     *         days: days
     *     }
     * })
     * ```
     */
    useQuery<TData = ListAdminFrUsageData>(
      parameters:
        | ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListAdminFrUsageData,
          ListAdminFrUsageError,
          TData,
          ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListAdminFrUsageError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.frUsageAdminService.listAdminFrUsage.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.frUsageAdminService.listAdminFrUsage.useQuery({
     *     query: {
     *         days: days
     *     }
     * })
     * ```
     */
    useQuery<TData = ListAdminFrUsageData>(
      parameters:
        | ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListAdminFrUsageData,
          ListAdminFrUsageError,
          TData,
          ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListAdminFrUsageError>>;
    /** @summary List Fr Usage */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListAdminFrUsageParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.frUsageAdminService.listAdminFrUsage.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             days: initialDays
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAdminFrUsageParameters,
      TQueryFnData = ListAdminFrUsageData,
      TData = OperationInfiniteData<TQueryFnData, ListAdminFrUsageParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAdminFrUsageError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListAdminFrUsageError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.frUsageAdminService.listAdminFrUsage.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             days: initialDays
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAdminFrUsageParameters,
      TQueryFnData = ListAdminFrUsageData,
      TData = OperationInfiniteData<TQueryFnData, ListAdminFrUsageParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAdminFrUsageError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAdminFrUsageData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListAdminFrUsageError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listAdminFrUsageTotal = qraft.frUsageAdminService.listAdminFrUsage.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listAdminFrUsageByParametersTotal = qraft.frUsageAdminService.listAdminFrUsage.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             days: days
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listAdminFrUsageResults = qraft.frUsageAdminService.listAdminFrUsage.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * listAdminFrUsageResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listAdminFrUsageCombinedResults = qraft.frUsageAdminService.listAdminFrUsage.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * listAdminFrUsageCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListAdminFrUsageSchema,
          ListAdminFrUsageParameters,
          ListAdminFrUsageData,
          ListAdminFrUsageError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListAdminFrUsageData, ListAdminFrUsageError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListAdminFrUsageData, ListAdminFrUsageError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.frUsageAdminService.listAdminFrUsage.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.frUsageAdminService.listAdminFrUsage.useSuspenseQuery({
     *     query: {
     *         days: days
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListAdminFrUsageData>(
      parameters:
        | ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListAdminFrUsageData,
          ListAdminFrUsageError,
          TData,
          ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListAdminFrUsageError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.frUsageAdminService.listAdminFrUsage.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             days: initialDays
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListAdminFrUsageParameters, TData = ListAdminFrUsageData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListAdminFrUsageData,
          ListAdminFrUsageError,
          OperationInfiniteData<TData, ListAdminFrUsageParameters>,
          ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAdminFrUsageData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListAdminFrUsageParameters>,
      OperationError<ListAdminFrUsageError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Fr Usage
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listAdminFrUsageData = qraft.frUsageAdminService.listAdminFrUsage.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * listAdminFrUsageResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listAdminFrUsageCombinedData = qraft.frUsageAdminService.listAdminFrUsage.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 days: days1
     *             }
     *         },
     *         {
     *             query: {
     *                 days: days2
     *             }
     *         }
     *     ]
     * });
     * listAdminFrUsageCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListAdminFrUsageSchema,
          ListAdminFrUsageParameters,
          ListAdminFrUsageData,
          ListAdminFrUsageError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListAdminFrUsageData, ListAdminFrUsageError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListAdminFrUsageData, ListAdminFrUsageError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Fr Usage */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        ListAdminFrUsageParameters,
        ListAdminFrUsageError
      > | void
    ): Promise<ListAdminFrUsageData>;
    /** @summary List Fr Usage */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        ListAdminFrUsageParameters,
        ListAdminFrUsageError
      > | void
    ): Promise<void>;
    /** @summary List Fr Usage */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        ListAdminFrUsageParameters,
        ListAdminFrUsageError
      > | void
    ): Promise<ListAdminFrUsageData>;
    /** @summary List Fr Usage */
    fetchInfiniteQuery<TPageParam extends ListAdminFrUsageParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        ListAdminFrUsageParameters,
        DeepReadonly<TPageParam>,
        ListAdminFrUsageError
      > | void
    ): Promise<OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters>>;
    /** @summary List Fr Usage */
    prefetchInfiniteQuery<TPageParam extends ListAdminFrUsageParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        ListAdminFrUsageParameters,
        DeepReadonly<TPageParam>,
        ListAdminFrUsageError
      > | void
    ): Promise<void>;
    /** @summary List Fr Usage */
    ensureInfiniteQueryData<TPageParam extends ListAdminFrUsageParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        ListAdminFrUsageParameters,
        DeepReadonly<TPageParam>,
        ListAdminFrUsageError
      > | void
    ): Promise<OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters>>;
    /** @summary List Fr Usage */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void)
    ): ListAdminFrUsageData | undefined;
    /** @summary List Fr Usage */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void)
    ): OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters> | undefined;
    /** @summary List Fr Usage */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
            data: NoInfer<OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
            data: ListAdminFrUsageData | undefined,
          ]
        >;
    /** @summary List Fr Usage */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | (DeepReadonly<ListAdminFrUsageParameters> | void)
    ): QueryState<ListAdminFrUsageData, ListAdminFrUsageError> | undefined;
    /** @summary List Fr Usage */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListAdminFrUsageParameters>
        | ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters>, ListAdminFrUsageError>
      | undefined;
    /** @summary List Fr Usage */
    setQueryData(
      parameters:
        | (DeepReadonly<ListAdminFrUsageParameters> | undefined)
        | ServiceOperationQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
      updater: Updater<
        NoInfer<ListAdminFrUsageData> | undefined,
        NoInfer<DeepReadonly<ListAdminFrUsageData>> | undefined
      >,
      options?: SetDataOptions
    ): ListAdminFrUsageData | undefined;
    /** @summary List Fr Usage */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListAdminFrUsageParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListAdminFrUsageSchema, ListAdminFrUsageParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListAdminFrUsageData, ListAdminFrUsageParameters> | undefined;
    /** @summary List Fr Usage */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >,
      updater: Updater<NoInfer<ListAdminFrUsageData> | undefined, NoInfer<ListAdminFrUsageData> | undefined>,
      options?: SetDataOptions
    ): Array<ListAdminFrUsageData | undefined>;
    /** @summary List Fr Usage */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListAdminFrUsageSchema,
        ListAdminFrUsageData,
        TInfinite,
        ListAdminFrUsageParameters,
        ListAdminFrUsageError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Fr Usage */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Fr Usage */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Fr Usage */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
    ): void;
    /** @summary List Fr Usage */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Fr Usage */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
        | QueryFiltersByQueryKey<
            ListAdminFrUsageSchema,
            ListAdminFrUsageData,
            TInfinite,
            ListAdminFrUsageParameters,
            ListAdminFrUsageError
          >
    ): number;
    schema: ListAdminFrUsageSchema;
    types: {
      parameters: ListAdminFrUsageParameters;
      data: ListAdminFrUsageData;
      error: ListAdminFrUsageError;
    };
  };
}
/** @summary List Fr Usage */
export const listAdminFrUsage = {
  schema: {
    method: 'get',
    url: '/admin/fr_usage/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListAdminFrUsageSchema;
  [QraftServiceOperationsToken]: FrUsageAdminService['listAdminFrUsage'];
};
export const frUsageAdminService = {
  listAdminFrUsage,
} as const;
type ListAdminFrUsageSchema = {
  method: 'get';
  url: '/admin/fr_usage/';
  security: ['HTTPBearer'];
};
type ListAdminFrUsageParameters = paths['/admin/fr_usage/']['get']['parameters'];
type ListAdminFrUsageData = paths['/admin/fr_usage/']['get']['responses']['200']['content']['application/json'];
type ListAdminFrUsageError = paths['/admin/fr_usage/']['get']['responses']['422']['content']['application/json'];
